import { useMemo } from 'react'

import {
  getBandCoverage,
  getRequirementBands
} from '../../../helpers/requirement-bands'

/**
 * Anforderung der gewählten Stelle im Teamprofil. Die Bereiche erscheinen
 * automatisch, sobald die Stelle Bereiche für mindestens eine Skala des Teams
 * hat. Ob sie ausgeblendet sind, entscheidet der Aufrufer (URL-Parameter
 * requirement=hidden im DiscoverContext), der Hook selbst hält keinen Zustand.
 */
export const useTeamRequirementOverlay = ({
  career,
  careerId,
  reportSettings,
  dimensions,
  isHidden = false
}) => {
  // Solange noch die vorherige Stelle im Cache steht, keine fremden Bereiche zeigen
  const careerAnalyse =
    career?.id && career.id === careerId ? career.career_analyse : null

  const bandsByKey = useMemo(
    () => getRequirementBands({ careerAnalyse, reportSettings }),
    [careerAnalyse, reportSettings]
  )

  const coverage = useMemo(
    () => getBandCoverage(bandsByKey, dimensions),
    [bandsByKey, dimensions]
  )

  // Ohne Skalen im Team (Query fehlgeschlagen, keine gemeinsamen Dimensionen)
  // gibt es nichts zu überlagern, das ist kein fehlender Bereich der Stelle
  const hasScales =
    coverage.withBands + coverage.withoutBands + coverage.unbandedInterests > 0
  const hasBands = coverage.withBands > 0
  const isVisible = hasBands && !isHidden

  return {
    hasScales,
    hasBands,
    isVisible,
    hasPartialBands: isVisible && coverage.withoutBands > 0,
    hasUnbandedInterests: isVisible && coverage.unbandedInterests > 0,
    hasMandatory: isVisible && coverage.mandatory > 0,
    requirementByDimension: isVisible ? bandsByKey : null
  }
}
